<template>
  <div>
    <SelectorPanel
      :text="title"
      :type="type"
      :hide-panel="true"
      @click="handleClick"
    >
    </SelectorPanel>
  </div>
</template>

<script>
import { EVENT_ACTIONS, EVENT_CATEGORIES } from "@/common/constants/analytics";

const EMITTED_ACTIONS = {
  CLICK: "click",
};

export default {
  name: "SimpleSelector",
  components: {
    SelectorPanel: () => import("@/components/common/SelectorPanel"),
  },
  props: {
    type: {
      type: String,
      validator: function (value) {
        return ["signout", "report", "dashboard", "firi"].indexOf(value) !== -1;
      },
    },
    title: {
      type: String,
      required: true,
    },
    url: {
      type: String,
    },
    redirectUrl: {
      type: String,
    },
  },
  methods: {
    async handleClick() {
      this.$emit(EMITTED_ACTIONS.CLICK);
      if (this.redirectUrl) {
        window.location = this.redirectUrl;
      }
      if (this.url) {
        window.open(this.url, "_blank");
      }
      if (this.type === "firi") {
        this.handlePageTrackerEvent(
          EVENT_CATEGORIES.firi,
          EVENT_ACTIONS.clicked,
          "Opened the Firi App"
        );
      }
    },
  },
};
</script>

<style></style>
